import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';

import { googleMapStyles, processGeoJSON } from '../modules/helpers';
import customInfoWindow from './custom-map-marker';
import getSchoolUrl from '../modules/get-url';

function makeMap(data) {
  const container = document.createElement('div');
  const key = document.createElement('div');
  const minimap = document.createElement('img');
  let markers = [];
  let clusterBounds = new window.google.maps.LatLngBounds();
  let map;

  function addMap(id, container, opts) {
    const elm = document.createElement('div');
    const mapOptions = Object.assign(
      {},
      {
        center: new window.google.maps.LatLng(-33.806431, 151.276418),
        zoom: 13,
        zoomControl: true,
        fullscreenControl: false,
        zoomControlOptions: {
          style: window.google.maps.ZoomControlStyle.DEFAULT,
          position: window.google.maps.ControlPosition.LEFT_TOP,
        },
        disableDoubleClickZoom: true,
        mapTypeControl: false,
        scaleControl: false,
        scrollwheel: false,
        panControl: true,
        streetViewControl: false,
        draggable: true,
        overviewMapControl: false,
        mapTypeId: window.google.maps.MapTypeId.ROADMAP,
      },
      opts
    );
    const map = new window.google.maps.Map(elm, mapOptions);
    elm.id = id;
    container.appendChild(elm);
    return map;
  }

  function addSchoolMarkers() {
    const infoWindow = new customInfoWindow();
    const activeIcon = '/img/icon-mapmarker-active.svg';
    const inactiveIcon = '/img/icon-mapmarker-inactive.svg';
    const activeIconMobile = '/img/icon-mapmarker-active-mobile.png';
    const inactiveIconMobile = '/img/icon-mapmarker-inactive-mobile.png';
    const inactiveSelectedMobile =
      '/img/icon-mapmarker-inactive-mobile-selected.png';
    data.schools.forEach((d, i) => {
      const classnames = d.isActive ? 'tooltip-active' : 'tooltip-arrow';
      const url = getSchoolUrl(d);
      let content = `<a href="${url}" target="_parent" class="tooltip ${classnames} tooltip-infowindow">
        <div class="tooltip-content-wrapper">
            <div class="tooltip-content">
            <div>
              <p class="tooltip-title">${d.name}</p>
            </div>
            </div>
          </div>
        </a>`;

      let iconsrc = d.isActive ? activeIcon : inactiveIcon;

      if (!window.matchMedia('(min-width: 600px)').matches) {
        iconsrc = d.isActive ? activeIconMobile : inactiveIconMobile;
      }

      const icon = {
        url: iconsrc,
        size: new window.google.maps.Size(20, 20),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(10, 10),
        scaledSize: new window.google.maps.Size(20, 20),
      };

      let marker = new window.google.maps.Marker({
        icon: icon,
        position: new window.google.maps.LatLng(d.location[1], d.location[0]),
        map: map,
        title: d.name,
        desc: 'content',
      });

      // Store original
      marker._icon = Object.assign({}, icon);
      markers.push(marker);

      marker.addListener('click', function() {
        return (function(_marker) {
          infoWindow.setContent(content);
          infoWindow.open(_marker.map, _marker);

          // Set all icons to original
          if (_marker.icon.url === inactiveIconMobile) {
            markers.forEach(m => {
              if (m.icon.url === inactiveSelectedMobile) {
                m.setIcon(m._icon);
              }
            });
            // Set clicked to clicked
            _marker.setIcon(
              Object.assign({}, _marker._icon, { url: inactiveSelectedMobile })
            );
          }
        })(marker);
      });

      map.addListener('zoom_changed', function() {
        infoWindow.close();
      });
    });
  }

  function loadClusterGeo() {
    return new Promise(function(resolve, reject) {
      map.data.addListener('addfeature', function(e) {
        processGeoJSON(
          e.feature.getGeometry(),
          clusterBounds.extend,
          clusterBounds
        );
        map.setCenter(clusterBounds.getCenter());
        map.fitBounds(clusterBounds);
        resolve();
      });

      map.data.loadGeoJson(`/data/clusters/${data.uid}.geojson`);

      map.data.setStyle({
        fillColor: '#ceebeb',
        strokeColor: '#00517D',
        strokeWeight: 2,
      });
    });
  }

  function drawMinimap() {
    const minimapstyles =
      'style=feature:all|visibility:off&style=feature:landscape|visibility:on|color:0xEAEAEA&style=feature:water|visibility:on|color:0xEAEAEA';
    const minimapsize = 'size=200x150';
    // http://www.freeformatter.com/javascript-escape.html
    const minimappath =
      'path=fillcolor:0xFFFFFFFF%7Ccolor:0xFFFFFF00%7Cenc:nzenE_d~y[ne`@nh\\~zm@~f^~lVnqPne`@n}@~`f@ntLn_eDninB~olG~qy@n|k@_|BnqPnbd@_etB~nwH_db@_mV_hpBn|k@_mVnsw@nbd@~lsCosw@nldJ~xFnh\\n_h@_|B?nggAoylD~gmFodkA~xFoyo@~jlBn_h@nvs@_`qAnkX_{m@~heA~lVnofB_db@~s`B_kw]n}@?_uqo@_`qAoljB_yFohyCn_h@_skCn~rA_fiA_ry@op{@nzD_ry@odkAnwH_xq@orbB~oR__|BonTotL?obd@oqPonTn}@_sN~xcCowHn{vA~wq@~jiFnp{@~k~D~oR~jlBndkAnaoA?nqPn_h@ne`@nkX~}i@~_qA~f^~lVn|hD~|tA';
    const clustercenter = clusterBounds.getCenter();
    const minimapapikey = 'key=AIzaSyAwRAI9ybH41VklsZdSJgye2sDAPj1-myI';
    const ne = [clustercenter.lat() + 0.5, clustercenter.lng() + 1];
    const se = [clustercenter.lat() - 0.5, clustercenter.lng() + 1];
    const sw = [clustercenter.lat() - 0.5, clustercenter.lng() - 1];
    const nw = [clustercenter.lat() + 0.5, clustercenter.lng() - 1];
    const minimapsq = `path=color:0x003E52ff|fillcolor:0xceebeb55|weight:1|${ne}|${se}|${sw}|${nw}|${ne}`;
    minimap.src =
      'https://maps.googleapis.com/maps/api/staticmap?' +
      minimapstyles +
      '&' +
      minimapsize +
      '&' +
      minimappath +
      '&' +
      minimapsq +
      '&' +
      minimapapikey;
    minimap.alt = 'Minimap showing schools group location in NSW';
    minimapapikey;
    container.classList.add('map-container');
    minimap.id = 'mini-map';
    container.appendChild(minimap);
  }

  function clearMarkers() {
    for (var i = 0; i < markers.length; i++) {
      markers[i].setMap(null);
    }
    markers = [];
  }

  function drawKey() {
    key.classList.add('map-key');
    let activeSchool = data.schools.filter(d => {
      return d.isActive;
    })[0];
    let keyactiveschool = activeSchool
      ? `<div class="map-key-point-active">${activeSchool.name}</div>`
      : '';
    let keyOtherSchools = activeSchool ? 'Other schools' : 'Schools';
    key.innerHTML = `<div class="map-key-poly">${data.name} schools group</div> <div class="map-key-point">${keyOtherSchools}</div> ${keyactiveschool}`;
    container.appendChild(key);
  }

  // start
  map = addMap('cluster-map', container, { styles: googleMapStyles });
  loadClusterGeo().then(() => {
    drawKey();
    drawMinimap();
    addSchoolMarkers();
  });

  window.addEventListener('resize', () => {
    clearMarkers();
    addSchoolMarkers();
    window.google.maps.event.addListenerOnce(map, 'idle', () => {
      map.fitBounds(clusterBounds);
    });
  });

  return { el: container, map };
}

class ClusterMap extends Component {
  wrapChart() {
    this.container = findDOMNode(this);
    while (this.container.firstChild) {
      this.container.removeChild(this.container.firstChild);
    }
    const { data } = this.props;
    const chart = makeMap(data);
    this.container.appendChild(chart.el);
  }

  componentDidMount() {
    this.wrapChart();
  }
  componentDidUpdate() {
    this.wrapChart();
  }

  render() {
    return <div />;
  }
}

export default ClusterMap;



// WEBPACK FOOTER //
// ./src/components/map.js